import React from "react";
import { Combobox } from "components/ui/combobox";
import { cn } from "lib/utils";
import { activeFilterClass } from "./filter-styles";
import { OrgLevelKey, OrgLevelOptions, ORG_LEVEL_KEYS } from "pages/shipments/api/shipments";

// Shown before the first response arrives, so the row doesn't jump
const PLACEHOLDER_LABELS: Record<OrgLevelKey, string> = {
  division: "Division",
  zone: "Zone",
  cluster: "Cluster",
  controlling_branch: "Controlling Branch",
  branch: "Branch/Project",
};

interface OrgFilterBarProps {
  levels: OrgLevelOptions[];
  onChange: (key: OrgLevelKey, value: string | undefined) => void;
  className?: string;
}

/** Division / Zone / Cluster / Controlling Branch / Branch-Project filter row. */
export function OrgFilterBar({ levels, onChange, className }: OrgFilterBarProps) {
  const byKey = new Map(levels.map((level) => [level.key, level]));

  return (
    <div className={cn("grid grid-cols-5 gap-3", className)}>
      {ORG_LEVEL_KEYS.map((key) => {
        const level = byKey.get(key);
        const label = level?.label ?? PLACEHOLDER_LABELS[key];
        const options = level?.options ?? [];

        return (
          <div key={key} className="flex min-w-0 flex-col gap-1">
            <span className="text-xs font-medium text-gray-700">{label}</span>
            <Combobox
              options={[
                { value: "", label: "All" },
                ...options.map((opt) => ({ value: opt.ou_code, label: opt.ou_name })),
              ]}
              value={level?.selected ?? ""}
              onValueChange={(value) => onChange(key, value || undefined)}
              placeholder="All"
              searchPlaceholder={`Search ${label.toLowerCase()}...`}
              emptyText={`No ${label.toLowerCase()} found.`}
              disabled={options.length === 0}
              buttonClassName={cn("h-8 text-xs font-normal", level?.selected && activeFilterClass)}
            />
          </div>
        );
      })}
    </div>
  );
}
